module.exports = __webpack_public_path__ + "static/media/guardian-logo.a91ee3ab.png";